export default "__VITE_ASSET__qwVgetpF__"